var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Fragment, useEffect, useState } from 'react';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { Builder, useIsPreviewing } from '@builder.io/react';
import { css } from '@emotion/react';
import { Spinner } from '@zapier/design-system';
import { Entry } from './Entry';
import { NotFoundPage } from './NotFoundPage';
import { useTracking } from '../tracking';
import { withRendererContext } from './RendererContext';
import { withErrorBoundary } from '../ErrorBoundary';
export function PageUnwrapped(_a) {
    var { content, onContentLoaded } = _a, rest = __rest(_a, ["content", "onContentLoaded"]);
    const router = useRouter();
    const [pageData, setPageData] = useState(content === null || content === void 0 ? void 0 : content.data);
    const isPreviewing = useIsPreviewing();
    const { emitPackageComponentLoadEvent } = useTracking();
    useEffect(() => {
        emitPackageComponentLoadEvent({
            event_action: 'load',
        });
    }, [emitPackageComponentLoadEvent]);
    const { description, shareImageUrl, openToSearchEngines = false, title, } = pageData || {};
    if (router.isFallback) {
        return _jsx(FallbackPage, {});
    }
    if (!pageData && !isPreviewing) {
        return _jsx(NotFoundPage, {});
    }
    return (_jsxs(Fragment, { children: [_jsxs(Head, { children: [title && (_jsxs(Fragment, { children: [_jsx("title", { children: title }), _jsx("meta", { content: title, property: "og:title" }), _jsx("meta", { content: title, name: "twitter:title" })] })), description && (_jsxs(Fragment, { children: [_jsx("meta", { content: description, id: "meta-description", name: "description" }), _jsx("meta", { content: description, property: "og:description" }), _jsx("meta", { content: description, name: "twitter:description" })] })), shareImageUrl && (_jsxs(Fragment, { children: [_jsx("meta", { content: shareImageUrl, property: "og:image" }), _jsx("meta", { content: shareImageUrl, name: "twitter:image" }), _jsx("meta", { content: "summary_large_image", name: "twitter:card" })] })), !openToSearchEngines && (_jsx("meta", { content: "noindex, nofollow", name: "robots" })), _jsx("meta", { content: "width=device-width, initial-scale=1.0", name: "viewport" })] }), _jsx(Entry, Object.assign({ content: content, onContentLoaded: (data) => {
                    if (Builder.isEditing || Builder.isPreviewing) {
                        setPageData(data);
                    }
                    if (onContentLoaded) {
                        onContentLoaded(data);
                    }
                } }, rest))] }));
}
export function FallbackPage() {
    return (_jsx("div", Object.assign({ css: css({
            height: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }) }, { children: _jsx(Spinner, { size: "large" }) })));
}
export const Page = withErrorBoundary(withRendererContext(PageUnwrapped));
//# sourceMappingURL=Page.js.map